import CreateProgressDownload from "../UseCase/CreateProgressDownload";

const createProgressDownload: CreateProgressDownload = new CreateProgressDownload();

export default function getCreateProgressDownload(): CreateProgressDownload {
    return createProgressDownload;
}